import PedagogieConfig from './pedagogie-config';

export default PedagogieConfig;
